import * as Sentry from '@sentry/react';
import { api as AuthJS } from '__AUTHJS_URL__';

import { digestMessage } from '@/lib/util';
import { type AuthSession } from '@/types/index.d';

const authentication = {
	async signIn(): Promise<void> {
		const colorScheme = window.matchMedia('(prefers-color-scheme: dark)').matches
			? 'dark'
			: 'light';

		return await AuthJS.signIn({
			overlayOptions: {
				colorScheme,
				noCloseButton: false
			},
			triggerType: 'overlay'
		});
	},

	async userIsLoggedIn(): Promise<boolean> {
		try {
			const session = await AuthJS.getSession();

			if (session?.idToken?.payload?.email) {
				const userHash = await digestMessage(session.idToken.payload.email.toLowerCase());
				Sentry.setUser({ id: userHash });
			}

			return session !== null;
		} catch (error) {
			window.console.error(error);

			return false;
		}
	},

	async getOauthToken(): Promise<string> {
		const session = await AuthJS.getSession();

		return session?.idToken?.jwtToken ? session.idToken.jwtToken : '';
	},

	onSignedIn(callback: (session: AuthSession) => Promise<void>): void {
		AuthJS.onSignedIn = async (session: AuthSession) => await callback(session);
	},

	async getSession(): Promise<AuthSession> {
		return await AuthJS.getSession();
	},

	scheduleTokenRefreshAt(refreshTime: number): void {
		AuthJS.scheduleTokenRefreshAt(refreshTime);
	}
};

export default authentication;
